import { TEX } from '../config/constants';

/**
 * Lista declarativa de tudo que o `Preloader` carrega.
 *
 * Para adicionar um asset, inclua uma entrada aqui — nao edite o Preloader.
 * `type` mapeia direto para o metodo do loader (`image`, `svg`, `font`).
 * Caminhos sao relativos a `public/assets` (o loader ja aplica `setPath`).
 */
export const ASSET_MANIFEST = [
    // Base visual comum (Figma, tema grafite/lima) — public/assets/common
    { type: 'image', key: TEX.BG_GRAFITE, file: 'common/bg-grafite.png' },
    { type: 'image', key: TEX.LOGO_FIAT_ARCADE, file: 'common/logo-fiat-arcade.png' },
    { type: 'image', key: TEX.LOGO_ARGO_X, file: 'common/logo-argo-x.png' },
    { type: 'image', key: TEX.ICON_POST_IT, file: 'common/icon-post-it.png' },
    { type: 'image', key: TEX.ICON_MATERIAIS, file: 'common/icon-materiais.png' },
    { type: 'image', key: TEX.ICON_TROFEU, file: 'common/icon-trofeu.png' },
    { type: 'image', key: TEX.BG_LIMA, file: 'common/bg-lima.png' },
    { type: 'image', key: TEX.PASTA_ABERTA, file: 'common/pasta-aberta.png' },
    { type: 'image', key: TEX.PASTA_BLOQUEADA, file: 'common/pasta-bloqueada.png' },
    { type: 'image', key: TEX.TROFEU_OURO, file: 'common/trofeu-ouro.png' },
    { type: 'image', key: TEX.TROFEU_PRATA, file: 'common/trofeu-prata.png' },
    { type: 'image', key: TEX.TROFEU_BRONZE, file: 'common/trofeu-bronze.png' },
    { type: 'image', key: TEX.ICON_LIXEIRA, file: 'common/icon-lixeira.png' },
    { type: 'image', key: TEX.BTN_INSIGHTS_REDONDO, file: 'common/btn-insights-redondo.png' },
    { type: 'image', key: TEX.BTN_MATERIAIS_PILULA, file: 'common/btn-materiais.png' },
    { type: 'image', key: TEX.BTN_MATERIAIS_MINI, file: 'common/btn-materiais-mini.png' },
    { type: 'image', key: TEX.LOGO_ARGO_X_BRANCO, file: 'common/logo-argo-x-branco.png' },
    { type: 'image', key: TEX.LIVRO_MAIS_UM, file: 'common/livro-mais-um.png' },
    { type: 'image', key: TEX.ICON_INFO_PIXEL, file: 'common/icon-info.png' },

    // Player 1
    { type: 'image', key: TEX.P1_CLIENTE_NEUTRO, file: 'player1/cliente-neutro.png' },
    { type: 'image', key: TEX.P1_CLIENTE_CELULAR, file: 'player1/cliente-celular.png' },
    { type: 'image', key: TEX.P1_CLIENTE_DESCONFIADO, file: 'player1/cliente-desconfiado.png' },
    { type: 'image', key: TEX.P1_CLIENTE_PENSATIVO, file: 'player1/cliente-pensativo.png' },
    { type: 'image', key: TEX.P1_CLIENTE_PREOCUPADO, file: 'player1/cliente-preocupado.png' },
    { type: 'image', key: TEX.P1_CLIENTE_FELIZ, file: 'player1/cliente-feliz.png' },
    { type: 'image', key: TEX.P1_ICON_FIDELIZACAO, file: 'player1/icon-fidelizacao.png' },
    { type: 'image', key: TEX.P1_ICON_CONFIANCA, file: 'player1/icon-confianca.png' },
    { type: 'image', key: TEX.P1_ICON_AGILIDADE, file: 'player1/icon-agilidade.png' },
    { type: 'image', key: TEX.P1_ICON_CONEXAO, file: 'player1/icon-conexao.png' },
    { type: 'image', key: TEX.P1_ICON_LAMPADA, file: 'player1/icon-lampada.png' },

    // Modo Versus (os ícones do chat são <img> da camada DOM, fora do loader)
    { type: 'image', key: TEX.VS_CLIENTE_MARCOS, file: 'versus/cliente-marcos.png' },
    { type: 'image', key: TEX.VS_CLIENTE_FERNANDA, file: 'versus/cliente-fernanda.png' },
    { type: 'image', key: TEX.VS_FOTO_MARCOS, file: 'versus/foto-marcos.png' },
    { type: 'image', key: TEX.VS_FOTO_FERNANDA, file: 'versus/foto-fernanda.png' },
    { type: 'image', key: TEX.VS_BTN_ENVIAR, file: 'versus/btn-enviar.png' },
    { type: 'image', key: TEX.VS_BTN_FECHAR, file: 'versus/btn-fechar.png' },

    // Fundo e identidade
    { type: 'image', key: TEX.BG, file: 'background.jpg' },
    { type: 'image', key: TEX.LOGO, file: 'logo_scan_pixel.svg' },
    // Mesma arte da logo sob a chave usada pelos modais do Scan Pixel.
    { type: 'image', key: TEX.LOGO_SCAN, file: 'logo_scan_pixel.svg' },
    { type: 'image', key: TEX.LOGO_LAB, file: 'lab-pixel-logo.svg' },

    // Molduras
    { type: 'image', key: TEX.FRAME_UP, file: 'frame-superior-sp.svg' },
    { type: 'image', key: TEX.FRAME_DOWN, file: 'frame-inferior-sp.svg' },
    { type: 'image', key: TEX.FRAME_PIXEL, file: 'frame-pixel.svg' },
    { type: 'image', key: TEX.FRAME_MODAL, file: 'frame-modal-double-pixel.svg' },
    { type: 'image', key: TEX.FRAME_CARD, file: 'frame-card-default.svg' },

    // Botoes
    { type: 'image', key: TEX.BTN_ACTIVE, file: 'button-active.png' },
    { type: 'image', key: TEX.BTN_DISABLE, file: 'button-disable.png' },
    { type: 'image', key: TEX.BTN_MODAL, file: 'button-begin.png' },
    { type: 'image', key: TEX.BTN_HOME, file: 'button-inicio-sp.svg' },
    { type: 'svg', key: TEX.BTN_MATERIAIS, file: 'button-materiais.svg' },
    { type: 'svg', key: TEX.BTN_CONFIRM_ACTIVE, file: 'button-confirmar-lab-active.svg' },
    { type: 'svg', key: TEX.BTN_CONFIRM_DISABLE, file: 'button-confirmar-lab-disable.svg' },

    // Icones
    { type: 'svg', key: TEX.ICON_INFO, file: 'icon-info.svg' },
    { type: 'image', key: TEX.ICON_TIMER, file: 'icon-time.svg' },
    { type: 'image', key: TEX.ICON_BOOK, file: 'book-manual-svg.svg' },
    { type: 'svg', key: TEX.LOCK_OPEN, file: 'cadeado-aberto.svg', opts: { width: 16, height: 16 } },
    { type: 'svg', key: TEX.LOCK_CLOSED, file: 'cadeado-fechado.svg', opts: { width: 16, height: 16 } },
    // Menu Resolução: cadeado dos resultados bloqueados (28×30 no Figma)
    { type: 'svg', key: TEX.LOCK_RESULTADO, file: 'cadeado-fechado.svg', opts: { width: 28, height: 30 } },
    // Console arcade do Pixel 3 (Figma, image 1501, 995×318)
    { type: 'image', key: TEX.MR_CONSOLE, file: 'menu-resolucao/console.png' },
    // Ícone do modal "Aguarde o facilitador liberar uma surpresa!" (Figma image 1502, 120×120).
    { type: 'image', key: TEX.MR_PRESENTE, file: 'menu-resolucao/presente.png' },
    { type: 'image', key: TEX.FAC_ENGRENAGEM, file: 'menu-resolucao/engrenagem.png' }
];

/** Fontes web carregadas junto com as texturas. */
export const FONT_MANIFEST = [
    // Silkscreen fica só no @font-face do style.css: registrá-la aqui com o
    // arquivo Bold fazia o peso 400 (Regular) também sair em negrito.
    { key: 'Handjet', file: 'fonts/handjet/Handjet-VariableFont_ELGR,ELSH,wght.ttf' }
];

/**
 * Fontes declaradas por @font-face no style.css e apenas aguardadas pelo
 * Preloader (várias espessuras da mesma família não cabem em `load.font`).
 */
export const FONTES_CSS = [
    "400 24px 'Barlow Semi Condensed'",
    "500 24px 'Barlow Semi Condensed'",
    "600 24px 'Barlow Semi Condensed'",
    "italic 600 24px 'Barlow Semi Condensed'",
    "700 24px 'Barlow Semi Condensed'",
    "800 24px 'Barlow Semi Condensed'",
    "400 16px 'Silkscreen'",
    "700 24px 'Silkscreen'"
];
